/** English UI copy — the reference dictionary. `de.ts` must cover the
 * same keys (pinned by a test). Keys are dot-namespaced by feature. */
import { APP_NAME } from "../config/brand";

export const en = {
  "app.name": APP_NAME,
  "landing.login": "Log in",
  "landing.getStarted": "Get started",
  "landing.eyebrow": "telc & Goethe exam prep",
  "landing.h1": "Pass your German exam with confidence.",
  "landing.sub": "Full exam practice, a structured course and AI feedback for every level from A1 to C1 — telc and Goethe, in one place.",
  "landing.ctaPrimary": "Start learning",
  "landing.ctaSecondary": "See what's inside",
  "landing.boards": "Practice material modelled on the telc and Goethe exam formats.",
  "landing.statItems": "exam practice tasks",
  "landing.statLessons": "guided lessons",
  "landing.statWords": "vocabulary words",
  "landing.statLevels": "every level",
  "landing.featuresTitle": "Everything you need to reach the exam.",
  "landing.featuresSub": "Not a video course and not a flashcard app — the whole path from your first word to exam day.",
  "landing.f1t": "Exam practice",
  "landing.f1b": "2,736 tasks across reading, listening, writing and speaking, in the exact telc and Goethe formats, with instant marking.",
  "landing.f2t": "Guided course",
  "landing.f2b": "240 lessons on a clear path — vocabulary, a grammar rule, a table, a dialogue, drills and a short writing and speaking task each.",
  "landing.f3t": "Reference & review",
  "landing.f3b": "50 grammar tables and 7,200 words, always at hand, with spaced repetition so the words you learn actually stick.",
  "landing.f4t": "AI writing & speaking coach",
  "landing.f4b": "Write or speak, and get feedback in seconds — scored against the real exam criteria, with corrections.",
  "landing.f5t": "Mock exams",
  "landing.f5b": "Full timed practice exams that score each section against the 60% pass line, so you know where you stand before the real day.",
  "landing.f6t": "Your level check",
  "landing.f6b": "Six skill scores drawn from everything you do, plus the single next thing to work on — no guessing what to study.",
  "landing.pricingTitle": "Buy exactly what you need.",
  "landing.pricingSub": "A single level, a complete level, or a package for a whole school. Pay for one skill or the full path.",
  "landing.popular": "Most popular",
  "landing.planLearnerT": "One learner, one level",
  "landing.planLearnerB": "Buy just the course or just the exam practice for the level you're sitting. You are the account and the student.",
  "landing.planCompleteT": "Complete level",
  "landing.planCompleteB": "Course and exam practice together for a level, at a lower price than buying each half — with AI feedback included.",
  "landing.planSchoolT": "For schools",
  "landing.planSchoolB": "Multi-seat packages with every level. Create accounts for your students and manage them from one place.",
  "landing.finalTitle": "Ready to start?",
  "landing.finalSub": "Create an account and begin at your level. Your school or our team can unlock the rest.",
  "landing.footer": "German exam preparation for telc and Goethe.",
  "landing.howTitle": "From your first word to exam day.",
  "landing.step1t": "Check your level",
  "landing.step1b": "A short diagnostic places you on the CEFR ladder and shows your six skill scores — no guessing where to start.",
  "landing.step2t": "Learn and practise",
  "landing.step2b": "Work the guided course and drill real exam tasks side by side, with spaced repetition keeping every word you meet.",
  "landing.step3t": "Sit a mock exam",
  "landing.step3b": "A full timed exam scores each section against the 60% pass line, so exam day holds no surprises.",
  "landing.ladderNote": "every level covered",
  "nav.dashboard": "Dashboard",
  "nav.store": "Store",
  "store.title": "Store",
  "store.subtitle": "Add levels and AI credits to your account.",
  "store.levels": "Levels",
  "store.owned": "Owned",
  "store.credits": "{count} credits",
  "store.creditMonthly": "{credits} included each month",
  "credits.low": "Your school has used {percent}% of this month's AI allowance.",
  "credits.outAdmin": "Your school's AI allowance is used up for this month. Writing feedback, the speaking partner and answer explanations are paused until you top up.",
  "credits.outLearner": "Your school's AI allowance is used up for this month, so AI feedback is paused. Ask your teacher to top it up.",
  "credits.topUp": "Top up",
  "store.creditBalance": "AI credits",
  "store.creditsTitle": "AI credits",
  "store.creditsBody": "Credits power AI writing feedback, the speaking partner and answer explanations. Your package includes a monthly allowance; buy more here when you need it.",
  "store.kind.learn": "Course",
  "store.kind.practice": "Practice",
  "store.kind.complete": "Complete",
  "store.total": "Total",
  "store.itemCount": "{count} in cart",
  "store.placeOrder": "Place order",
  "store.orderPlaced": "Order placed — pay by bank transfer",
  "store.amountToPay": "Amount to pay",
  "store.reference": "Reference",
  "store.quoteReference": "Quote this reference on your transfer so we can match your payment.",
  "store.transferTo": "Transfer to",
  "store.accountName": "Account name",
  "store.accountNumber": "Account number",
  "store.bankName": "Bank",
  "store.ifsc": "IFSC",
  "store.orderItems": "Your order",
  "store.contact": "Questions? Contact",
  "nav.orders": "Orders",
  "nav.classes": "Classes",
  "tour.body.classes": "Decide who studies what. Assign levels to a class and every pupil in it gets them — or give one pupil something extra.",
  "classes.title": "Classes",
  "classes.subtitle": "Your school buys a level once; here you choose which pupils get it. Assign to a class and every member inherits it — then add extras for an individual.",
  "classes.newClass": "New class",
  "classes.name": "Class name",
  "classes.namePlaceholder": "e.g. Klasse 1, Abendkurs B1",
  "classes.create": "Create class",
  "classes.empty": "No classes yet. Create one to start assigning levels.",
  "classes.delete": "Delete",
  "classes.modules": "Levels this class gets",
  "classes.members": "Pupils in this class ({count})",
  "classes.noPupils": "No pupils yet — add them on the Team page first.",
  "classes.noModules": "Your school hasn't got any levels yet. Buy one in the Store first.",
  "classes.saved": "Saved.",
  "classes.individual": "One pupil at a time",
  "classes.individualBody": "For the exception — a pupil who needs something their class doesn't get. This adds to whatever their classes already give them.",
  "classes.pupil": "Pupil",
  "classes.choosePupil": "Choose a pupil…",
  "classes.extraModules": "Extra levels for this pupil",
  "classes.effective": "They can currently open",
  "classes.nothingYet": "nothing yet",
  "classes.grantAll": "Give them everything the school owns",
  "classes.autoGrant": "New pupils",
  "classes.autoGrantBody": "Automatically give a new pupil every level the school owns when they accept their invitation. Turn this off if you prefer to assign each pupil by hand.",
  "admin.orders.heading": "Bank-transfer orders",
  "admin.orders.headingSub": "Reconcile payments and manage the details learners transfer to.",
  "admin.orders.title": "Pending orders",
  "admin.orders.subtitle": "Mark an order paid once its transfer arrives — that unlocks the packs.",
  "admin.orders.none": "No pending orders.",
  "admin.orders.ref": "Reference",
  "admin.orders.tenant": "Account",
  "admin.orders.items": "Items",
  "admin.orders.amount": "Amount",
  "admin.orders.markPaid": "Mark paid",
  "admin.orders.cancel": "Cancel",
  "admin.orders.paidDone": "Order unlocked.",
  "admin.orders.cancelled": "Order cancelled.",
  "admin.pay.title": "Payment details",
  "admin.pay.subtitle": "The bank account and contact shown to learners on the transfer instructions.",
  "admin.pay.contactEmail": "Contact email",
  "admin.pay.note": "Note to buyers",
  "admin.pay.save": "Save",
  "admin.pay.saved": "Payment details saved.",
  "tour.help": "Show me around",
  "locked.title": "{level} {kind} isn't in your plan yet",
  "locked.body": "Nothing has gone wrong — this level simply isn't unlocked on your account. Add {level} {kind} in the Store and it opens straight away.",
  "locked.cta": "Get it in the Store",
  "learn.objectives": "By the end of this lesson you can",
  "learn.lineGloss": "Line by line",
  "learn.wordBank": "Vocabulary",
  "learn.pronunciation": "Pronunciation",
  "learn.minimalPairs": "Hear the difference",
  "learn.culture": "Culture",
  "learn.translation": "Translate into German",
  "learn.translationHint": "Write each sentence in German, then reveal the model answers.",
  "learn.showAnswers": "Show answers",
  "learn.lessonTest": "Check what you've learned",
  "learn.points": "points",
  "learn.submitTest": "Submit",
  "learn.yourScore": "Your score",
  "learn.recall": "Can you remember?",
  "learn.reveal": "Show answer",
  "learn.lockedBuy": "Not in your plan yet — get this level in the Store",
  "learn.lockedAsk": "Not in your plan yet — ask your school administrator to add this level.",
  "locked.askAdmin": "Ask your school administrator to add {level} {kind} to your account.",
  "locked.askAdminGeneric": "Ask your school administrator to unlock this for you.",
  "store.adminOnly": "Your school administrator orders levels for your account. Ask them to add what you need.",
  "locked.genericTitle": "This isn't unlocked on your account",
  "locked.genericBody": "Your plan doesn't include this yet. Open the Store to add it.",
  "tour.step": "{n} of {total}",
  "tour.next": "Next",
  "tour.back": "Back",
  "tour.skip": "Skip tour",
  "tour.done": "Got it",
  "tour.welcome.title": "Welcome — here's how it works",
  "tour.welcome.body": "A quick tour of where everything is and what to do first. It takes about 30 seconds, and you can replay it anytime with the ? button.",
  "tour.askDoubt.title": "Ask in your own language",
  "tour.askDoubt.body": "You practise in German, but you never have to be stuck in it. On any lesson or practice question, write your question in Hindi, Punjabi or English - the answer comes back in the same language.",
  "tour.final.title": "What to do first",
  "tour.final.body": "Start on your Dashboard — it shows the plan we recommend and your level check. Get a level from the Store, then open Learn and take lesson 1.",
  "tour.body.dashboard": "Your home. It shows the plan we recommend for you, your six skill scores, and the next thing to work on.",
  "tour.body.learn": "Your course, lesson by lesson in order. Each lesson has vocabulary, one grammar rule, a dialogue, drills, and a short writing and speaking task.",
  "tour.body.reference": "Look anything up at any time — grammar tables and word lists for every level, plus review that repeats words until they stick.",
  "tour.body.notebook": "Your private scratchpad. Jot down a rule, a word or a question while you study — it stays with your account and only you can see it.",
  "tour.body.store": "Get a level here. Choose the course, the exam practice, or both, then place your order. Lessons and practice stay locked until you have a level.",
  "tour.body.practice": "Real exam tasks in the telc and Goethe formats — reading, listening, writing and speaking, marked instantly. Full mock exams live here too.",
  "tour.body.speak": "Talk with the AI partner and get feedback on your speaking, scored the way an examiner would.",
  "tour.body.team": "Add teachers and students to your school and manage their accounts.",
  "tour.body.access": "Decide who can see and do what — grant or remove permissions per person.",
  "tour.body.billing": "Your plan, invoices and payments.",
  "tour.body.tenants": "Every school on the platform — create one, inspect it, and manage its modules.",
  "tour.body.orders": "Bank-transfer orders waiting to be reconciled. Mark one paid to unlock its packs.",
  "tour.body.revenue": "What the platform is earning, across all schools.",
  "tour.body.ai": "Choose which AI provider answers the platform's prompts.",
  "tour.body.aiUsage": "See how many AI tokens your learners are using each month.",
  "usage.name": "Name",
  "store.error": "Something went wrong. Please try again.",
  "store.recommended": "Recommended",
  "admin.credits.title": "AI credits",
  "admin.credits.thisMonth": "{granted} granted, {spent} spent this month",
  "admin.credits.amount": "Amount",
  "admin.credits.reason": "Reason",
  "admin.credits.reasonHint": "e.g. goodwill, refund, correction",
  "admin.credits.apply": "Apply adjustment",
  "admin.credits.done": "Balance updated.",
  "admin.credits.asTokens": "= {tokens} tokens",
  "admin.credits.monthlyAsTokens": "That is {tokens} tokens a month. Credits, not tokens - 1 credit = 100 tokens.",
  "admin.credits.monthly": "Monthly allowance",
  "admin.credits.monthlyHint": "Credits granted automatically at the start of each month. 0 uses the plan's allowance. Changes apply from next month's grant.",
  "admin.credits.monthlySave": "Save allowance",
  "admin.credits.monthlySaved": "Monthly allowance saved.",
  "admin.credits.failed": "Could not adjust the balance.",
  "nav.reference": "Reference",
  "nav.notebook": "Notebook",
  "notebook.tabNotes": "Notes",
  "notebook.tabWriting": "Writing practice",
  "writing.intro": "Write something in German and the coach will mark it - a score, the corrections that matter, and what to practise next. Anything you like: a diary entry, an email, an opinion.",
  "writing.level": "Level",
  "writing.levelHint": "What to be judged against.",
  "writing.topic": "Topic",
  "writing.topicHint": "optional",
  "writing.topicPlaceholder": "e.g. my weekend, my job",
  "writing.yourText": "Your text",
  "writing.placeholder": "Schreiben Sie hier auf Deutsch...",
  "writing.words": "words",
  "writing.submit": "Get feedback",
  "writing.past": "Earlier pieces",
  "writing.corrections": "Corrections",
  "writing.improvements": "To improve",
  "writing.whatYouWrote": "What you wrote",
  "writing.again": "Write another",
  "writing.noFeedback": "No feedback was recorded for this piece.",
  "writing.notConfigured": "The AI writing coach is not activated on this server yet — please ask your administrator.",
  "notebook.moveTo": "Move to tab",
  "notebook.bold": "Bold",
  "notebook.highlight": "Highlight",
  "notebook.formatHint": "select text, then B or H",
  "notebook.allNotes": "General",
  "notebook.newSection": "+ new tab",
  "notebook.source": "Saved from a lesson",
  "placement.title": "Where should you start?",
  "placement.subtitle": "A few questions, easiest first. Answer what you can and skip what you cannot - that is the point.",
  "placement.progress": "Question {current} of {total}",
  "placement.next": "Next",
  "placement.back": "Back",
  "placement.finish": "See my level",
  "placement.dontKnowHint": "Not sure? Leave it and move on - guessing does not help us place you.",
  "placement.noQuestions": "No placement questions are available yet.",
  "placement.skipQuestion": "This question cannot be shown - move on.",
  "placement.startHere": "Start here",
  "placement.reasonNext": "You handled the levels below this comfortably, so this is where the course should begin for you.",
  "placement.reasonBeginner": "We will start you from the beginning. That is the right place for most people - the first lessons go quickly if you already know some German.",
  "placement.reasonTop": "You answered everything we asked. This is the highest level we teach today.",
  "placement.startLearning": "Start the course",
  "placement.goPractice": "Try the practice questions",
  "notebook.saveHere": "Save to my notebook",
  "notebook.saveTitle": "Keep this in your notebook",
  "notebook.saveFrom": "From {lesson} - your note will link back here.",
  "notebook.savePlaceholder": "Select text on the page first, or type it here",
  "notebook.saved": "Saved to your notebook.",
  "levels.title": "Your levels",
  "levels.lessons": "{done}/{total} lessons",
  "levels.practice": "{done}/{total} practice parts",
  "levels.markComplete": "Mark complete",
  "levels.done": "Completed",
  "levels.undo": "Undo",
  "levels.keepGoing": "Keep going",
  "levels.wellDone": "{level} complete - well done.",
  "notebook.title": "My notebook",
  "notebook.subtitle": "A private scratchpad for rules, words and doubts — only you can see it.",
  "notebook.placeholder": "Write a note…",
  "notebook.add": "Add note",
  "notebook.edit": "Edit",
  "notebook.delete": "Delete",
  "notebook.empty": "No notes yet. Jot down your first one above.",
  "reference.title": "Reference library",
  "reference.subtitle": "Grammar rules, tables and vocabulary for every level — look anything up at any time.",
  "reference.grammar": "Grammar",
  "reference.vocab": "Vocabulary",
  "reference.tables": "Tables",
  "reference.rules": "Rules",
  "reference.search": "Search…",
  "reference.noResults": "Nothing matches your search.",
  "reference.wordCount": "{count} words at this level",
  "review.tab": "Review",
  "review.due": "{count} due today",
  "review.learned": "{count} of {total} learned",
  "review.sessionDone": "Session complete",
  "review.reviewed": "You reviewed {count} words.",
  "review.again": "Review more",
  "review.position": "{n} of {total}",
  "review.newWord": "New word",
  "review.box": "Box {box}",
  "review.reveal": "Show meaning",
  "review.plural": "Plural",
  "review.forgot": "I forgot",
  "review.knew": "I knew it",
  "review.empty": "Nothing to review right now.",
  "kc.title": "Your level check",
  "kc.doNext": "Do this next",
  "kc.notStarted": "not started",
  "kc.needMore": "{count} more to unlock",
  "kc.overallLocked": "{count} more skills to unlock",
  "kc.action.review_vocab": "Review {count} words that are due",
  "kc.action.start_skill": "Start {skill} — {count} tasks unlocks your score",
  "kc.action.finish_evidence": "{count} more in {skill} to unlock your score",
  "kc.action.improve_skill": "Work on {skill} — currently {count}%",
  "skill.wortschatz": "Vocabulary",
  "skill.grammatik": "Grammar",
  "skill.lesen": "Reading",
  "skill.hoeren": "Listening",
  "skill.schreiben": "Writing",
  "skill.sprechen": "Speaking",
  "nav.team": "Team",
  "nav.access": "Access",
  "nav.tenants": "Tenants",
  "nav.billing": "Billing",
  "nav.revenue": "Revenue",
  "nav.profile": "My account",

  "profile.title": "My account",
  "profile.subtitle": "Update your details and password.",
  "profile.details": "Profile details",
  "profile.fullName": "Full name",
  "profile.phone": "Phone",
  "profile.voice": "Voice",
  "profile.voiceHint": "The voice the speaking partner and listening exercises use.",
  "profile.language": "Language",
  "profile.emailLocked": "Contact support to change your email address.",
  "profile.saved": "Profile updated.",
  "profile.password.title": "Password",
  "profile.password.current": "Current password",
  "profile.password.new": "New password",
  "profile.password.confirm": "Confirm new password",
  "profile.password.submit": "Change password",
  "profile.password.mismatch": "The new passwords don't match.",
  "profile.password.changed": "Password changed.",
  "profile.aiUsage": "AI usage",
  "twofa.title": "Two-factor authentication",
  "twofa.on": "Two-factor authentication is on",
  "twofa.off": "Add a second step at login for extra security.",
  "twofa.enable": "Enable",
  "twofa.disable": "Disable",
  "twofa.disabled": "Two-factor authentication turned off.",
  "twofa.code": "Code from your app",
  "twofa.scanIntro": "Scan this with your authenticator app, then enter the 6-digit code to confirm.",
  "twofa.manualKey": "Can't scan? Enter this key manually:",
  "twofa.recoveryIntro": "Save these recovery codes somewhere safe — each works once if you lose your device. You won't see them again.",
  "twofa.done": "Done",
  "twofa.disableIntro": "Enter a current code (or a recovery code) to turn off two-factor authentication.",
  "usage.today": "Today",
  "usage.thisWeek": "This week",
  "usage.thisMonth": "This month",
  "usage.left": "{pct}% left",
  "usage.used": "{used} of {limit} tokens used",
  "usage.learners": "AI usage by learner",
  "usage.tenants": "AI usage by tenant",
  "usage.tokensThisMonth": "Tokens this month",
  "usage.none": "No AI usage yet.",
  "nav.aiUsage": "AI usage",
  "nav.group.learn": "Learn",
  "nav.group.practice": "Practice",
  "nav.group.school": "School",
  "nav.group.account": "Account",
  "nav.group.revenue": "Revenue",
  "nav.group.platform": "Tenants",
  "nav.group.ai": "AI",
  "nav.menu": "Menu",
  "nav.closeMenu": "Close menu",
  "nav.switchLanguage": "Switch language",
  "nav.notifications": "Notifications",
  "nav.logout": "Log out",

  "auth.email": "Email",
  "auth.password": "Password",
  "auth.login": "Sign in",
  "auth.login.title": "Welcome back",
  "auth.2fa.title": "Two-factor authentication",
  "auth.2fa.subtitle": "Enter the 6-digit code from your authenticator app (or a recovery code).",
  "auth.2fa.code": "Authentication code",
  "auth.2fa.verify": "Verify",
  "auth.login.subtitle": "Sign in to your workspace",
  "auth.forgot": "Forgot password?",
  "auth.forgot.title": "Reset your password",
  "auth.forgot.subtitle": "We'll email you a reset link.",
  "auth.forgot.submit": "Send reset link",
  "auth.reset.title": "Choose a new password",
  "auth.reset.password": "New password",
  "auth.reset.submit": "Set new password",
  "auth.reset.done": "Password set. You can sign in now.",
  "auth.invite.title": "Set up your account",
  "auth.invite.for": "You're setting up the account for",
  "auth.invite.submit": "Activate account",
  "auth.backToLogin": "Back to sign in",
  "auth.name": "Your name",
  "auth.signup.title": "Create your account",
  "auth.signup.subtitle": "Start learning German — pick your plan later, not now.",
  "auth.createAccount": "Create account",
  "auth.passwordHint": "At least 8 characters.",
  "auth.haveAccount": "Already have an account?",
  "auth.newHere": "New here?",
  "onboarding.title": "Let's set you up",
  "onboarding.subtitle": "Five quick questions so we can point you to the right level and plan. You choose what to buy later.",
  "onboarding.stepOf": "Step {n} of {total}",
  "onboarding.back": "Back",
  "onboarding.next": "Next",
  "onboarding.finish": "See my recommendation",
  "onboarding.q.goal": "Why are you learning German?",
  "onboarding.q.board": "Which exam are you aiming for?",
  "onboarding.q.level": "How much German do you have now?",
  "onboarding.q.focus": "Which level do you want to focus on now?",
  "onboarding.q.timeline": "How much time can you give it?",
  "onboarding.goal.exam": "Pass an exam",
  "onboarding.goal.work": "Work & career",
  "onboarding.goal.study": "University study",
  "onboarding.goal.immigration": "Living in Germany",
  "onboarding.goal.travel": "Travel & personal",
  "onboarding.board.telc": "telc",
  "onboarding.board.goethe": "Goethe",
  "onboarding.board.either": "Not sure yet",
  "onboarding.level.none": "Complete beginner",
  "onboarding.level.A1": "A1 — basic phrases",
  "onboarding.level.A2": "A2 — everyday basics",
  "onboarding.level.B1": "B1 — independent",
  "onboarding.level.B2": "B2 — confident",
  "onboarding.level.C1": "C1 — advanced",
  "onboarding.quickCheck": "Not sure? Help me choose",
  "onboarding.quickCheck.q": "Which best describes you?",
  "onboarding.quick.none": "I'm just starting out.",
  "onboarding.quick.A1": "I can introduce myself and order food.",
  "onboarding.quick.A2": "I can talk about my day and past events.",
  "onboarding.quick.B1": "I can handle travel and explain my opinions.",
  "onboarding.quick.B2": "I can discuss abstract topics with ease.",
  "onboarding.quick.C1": "I can express myself fluently on complex topics.",
  "onboarding.timeline.relaxed": "Relaxed — a little each week",
  "onboarding.timeline.steady": "Steady — a few times a week",
  "onboarding.timeline.intensive": "Intensive — most days",
  "dashboard.rec.eyebrow": "Your recommendation",
  "dashboard.rec.headline": "We suggest {level} — Complete",
  "dashboard.rec.cta": "See your plan",
  "dashboard.rec.bothBoards": "telc and Goethe",
  "dashboard.rec.credits": "Plus AI credits for writing and speaking feedback.",
  "dashboard.rec.reason.exam": "You're preparing for an exam, so Complete pairs the {level} course with full {board} exam practice — plus AI feedback that scores your writing and speaking.",
  "dashboard.rec.reason.work": "For work, Complete builds your {level} end to end — the course, exam-style practice and AI feedback.",
  "dashboard.rec.reason.study": "For university, Complete takes you through {level} systematically — course, {board}-format practice and AI feedback.",
  "dashboard.rec.reason.immigration": "For life in Germany, Complete covers {level} from everyday vocabulary to the {board} exam, with AI feedback.",
  "dashboard.rec.reason.travel": "Complete gives you a solid {level} — the course, practice and AI feedback, so it sticks.",

  "dashboard.greeting.morning": "Guten Morgen",
  "dashboard.greeting.day": "Guten Tag",
  "dashboard.greeting.evening": "Guten Abend",
  "dashboard.subtitle": "Here's what's happening in your workspace.",
  "dashboard.admin.tenants": "Manage schools, seats and modules.",
  "dashboard.admin.orders": "Bank-transfer orders awaiting confirmation.",
  "dashboard.admin.revenue": "Payments and revenue across all tenants.",
  "dashboard.admin.ai": "Choose the AI provider and manage keys.",

  "team.title": "Team",
  "team.invite": "Invite member",
  "team.invite.title": "Invite a team member",
  "team.invite.name": "Full name",
  "team.invite.role": "Role",
  "team.invite.submit": "Send invite",
  "team.resend": "Re-send invite",
  "team.deactivate": "Deactivate",
  "team.activate": "Activate",
  "team.status.active": "Active",
  "team.status.inactive": "Inactive",
  "team.status.invited": "Invited",

  "access.title": "Access",
  "access.subtitle": "Grant or revoke capabilities beyond a member's role.",
  "access.domain": "Area",
  "access.read": "Read",
  "access.write": "Write",
  "access.granted": "granted",
  "access.revoked": "revoked",
  "access.default": "role default",

  "tenants.title": "Tenants",
  "tenants.provision": "New tenant",
  "tenants.provision.title": "Provision a tenant",
  "tenants.legalName": "Legal name",
  "tenants.subdomain": "Subdomain",
  "tenants.tier": "Plan",
  "tenants.adminEmail": "Admin email",
  "tenants.adminName": "Admin full name",
  "tenants.provision.submit": "Provision",
  "tenants.provisioned": "Tenant provisioned. Invite link (also emailed):",
  "tenants.levels": "Levels this school has bought",
  "tenants.levelsHint": "Each level adds its course and its exam practice. You can change this later on the school's page.",
  "tenants.levelsAll": "Select all",
  "tenants.levelsNone": "Clear",
  "tenants.provisionedNoEmail": "School created. Email isn't configured on this server, so send this link to the admin yourself:",
  "tenants.seats": "Seats",
  "tenants.modules": "Modules",
  "tenants.active": "Active",
  "tenants.inactive": "Inactive",
  "tenants.seatPreview": "{n} user(s) would be deactivated by this change.",
  "tenants.save": "Save changes",

  "notifications.title": "Notifications",
  "notifications.empty": "You're all caught up.",
  "notifications.markAll": "Mark all read",

  "nav.learn": "The course",
  "learn.title": "Courses",
  "learn.subtitle": "Your German course, level by level.",
  "learn.enroll": "Enroll",
  "learn.enrolled": "Enrolled",
  "learn.continue": "Continue where you left off",
  "learn.resume": "Resume",
  "learn.start": "Start",
  "learn.review": "Review",
  "learn.completed": "Completed",
  "learn.lessons": "lessons",
  "learn.mastery": "Mastery",
  "learn.xp": "XP",
  "learn.empty": "No courses published yet.",
  "nav.practice": "Exam practice",
  "nav.speak": "Speak",
  "bot.title": "Speaking partner",
  "bot.subtitle": "Talk freely with your AI partner — it keeps going until you stop.",
  "bot.intro": "Press start once, then just talk. Your partner listens, answers out loud, and the microphone re-arms itself — no buttons between turns. End it whenever you like and you'll get feedback.",
  "bot.language": "Language",
  "bot.level": "Level",
  "bot.levelAuto": "Auto (adapt to me)",
  "bot.levelAutoHint": "We'll pick a level as we get to know your speaking.",
  "bot.levelAutoAt": "Based on your recent chats, we'll start around {level}.",
  "bot.topic": "Topic",
  "bot.topicHint": "optional — leave empty for free chat",
  "bot.howTitle": "How this works",
  "bot.howSpeak": "Just speak - the microphone is already on. You do not press anything between turns.",
  "bot.howPause": "Take your time. Pausing to think is fine; it keeps listening.",
  "bot.howStuck": "Stuck for a word? Say it in English, or type your reply in the box below.",
  "bot.howEnd": "Press End when you have had enough, and you get feedback on how you did.",
  "bot.partnerSpeaking": "Your partner is speaking...",
  "bot.voice": "Voice",
  "bot.voiceHintServer": "male or female - saved to your account, so it follows you to every device",
  "bot.voiceMale": "Male voice",
  "bot.voiceFemale": "Female voice",
  "bot.voiceHint": "optional — some voices sound far more natural than others",
  "bot.voiceAuto": "Best available",
  "bot.voiceTest": "Hear it",
  "bot.past": "Past conversations",
  "bot.backToStart": "Back",
  "bot.resumed": "Picked up where you left off. Press continue when you are ready to talk.",
  "bot.continue": "Continue talking",
  "bot.topicPlaceholder": "e.g. travel, my job, food…",
  "bot.start": "Start talking",
  "bot.end": "End & get feedback",
  "practice.title": "Practice Center",
  "practice.status.preparingFor": "You're preparing for",
  "practice.status.updateGoal": "Update goal",
  "practice.status.nextUp": "Next up",
  "practice.status.noGoal": "Tell us your goal to personalise your practice.",
  "practice.status.setGoal": "Set my goal",
  "practice.status.goal.exam": "Getting you exam-ready.",
  "practice.status.goal.work": "German for your work.",
  "practice.status.goal.study": "German for your studies.",
  "practice.status.goal.immigration": "German for living in Germany.",
  "practice.status.goal.travel": "German for travel.",
  "practice.subtitle": "Practice every section of the exam in the real format.",
  "practice.practices": "practices",
  "practice.progress": "Progress",
  "practice.start": "Start Practice",
  "practice.submit": "Submit",
  "practice.result": "Result",
  "practice.tryAgain": "Try again",
  "practice.backToPart": "Back to practice",
  "practice.yourAnswer": "Your answer",
  "practice.correctAnswer": "Correct answer",
  "practice.true": "Richtig",
  "practice.false": "Falsch",
  "practice.choose": "Choose…",
  "practice.best": "Best",
  "practice.filter.all": "All",
  "practice.filter.notStarted": "Not started",
  "practice.filter.keepPracticing": "Keep practicing",
  "practice.filter.mastered": "Mastered",
  "practice.readyToStart": "Ready to start",
  "practice.practicedLabel": "Practiced",
  "practice.mastery": "Mastery",
  "practice.search": "Search practices…",
  "practice.minutes": "min",
  "practice.howToApproach": "How to approach this",
  "practice.unanswered": "{n} unanswered",
  "practice.allAnswered": "All answered",
  "practice.exam.cta": "Full practice exam",
  "practice.exam.ctaBody": "Sit the complete exam on the clock, then get scored section by section.",
  "practice.exam.start": "Start exam",
  "practice.exam.introBody": "{sections} sections · about {minutes} min · {questions} questions. Reading, grammar and listening are scored instantly; writing and speaking are practised separately.",
  "practice.exam.begin": "Begin exam",
  "practice.exam.allowed": "Allowed: {minutes} min",
  "practice.exam.finish": "Finish & score",
  "practice.exam.passed": "Passed",
  "practice.exam.notPassed": "Keep practicing",
  "practice.exam.bySection": "By section",
  "practice.exam.note": "Writing and speaking are practised separately with the AI coaches.",
  "practice.exam.retake": "New exam",
  "practice.exam.history": "Your recent attempts",
  "practice.readiness.label": "Exam readiness",
  "practice.readiness.detail": "{practiced} of {total} tasks practised",
  "practice.readiness.review": "Review your mistakes",
  "practice.readiness.avgLabel": "Average score so far",
  "practice.readiness.needMore": "Practise {count} more tasks for a readiness estimate.",
  "practice.readiness.needSections": "Not started yet: {sections}",
  "practice.readiness.band.needsWork": "Needs work",
  "practice.readiness.band.onTrack": "On track",
  "practice.readiness.band.examReady": "Exam ready",
  "practice.review.subtitle": "Tasks you haven't mastered yet — worst first. Practise them again to raise your readiness.",
  "practice.review.empty": "Nothing to review — every task you've tried is mastered. Nice!",
  "practice.explain.get": "Get AI explanation",
  "practice.explain.notConfigured": "AI explanations aren't activated on this server yet.",
  "practice.exam.band.sehrGut": "Very good",
  "practice.exam.band.gut": "Good",
  "practice.exam.band.bestanden": "Pass",
  "practice.exam.band.nichtBestanden": "Not yet",
  "practice.allThemes": "All themes",
  "practice.previous": "Previous",
  "practice.next": "Next",
  "practice.pageOf": "Page {page} of {total}",

  "writing.aiCoach": "AI writing coach",
  "writing.getFeedback": "Get AI feedback",
  "writing.feedback": "AI feedback",
  "writing.levelEstimate": "Level estimate",
  "writing.content": "Content",
  "writing.structure": "Structure & tone",
  "writing.language": "Language accuracy",
  "writing.taskPoints": "Task points",
  "writing.strengths": "Strengths",
  "writing.revise": "Revise & resubmit",
  "writing.draftNote": "Draft note",
  "writing.draftNoteHint": "sketch your ideas first — not graded",
  "writing.previous": "Previous feedback",
  "writing.quotaUsed": "AI feedback this month: {used} / {limit}",

  "speaking.aiPartner": "AI speaking partner",
  "speaking.notConfigured": "The AI speaking partner is not activated on this server yet — please ask your administrator.",
  "speaking.micUnavailable": "Voice input isn't available in this browser — you can type your replies instead.",
  "speaking.start": "Start conversation",
  "orb.speaking": "Your partner is speaking",
  "orb.listening": "Your turn - speak when you are ready",
  "orb.thinking": "Thinking...",
  "orb.idle": "Ready",
  "speaking.listening": "Listening…",
  "speaking.thinking": "Thinking…",
  "speaking.typeFallback": "Type your reply",
  "speaking.send": "Send",
  "speaking.end": "End & get feedback",
  "speaking.turns": "Turn {turns} of {max}",
  "speaking.turnsWord": "turns",
  "speaking.quotaUsed": "AI conversations this month: {used} / {limit}",
  "speaking.feedback": "Conversation feedback",
  "speaking.interaction": "Interaction & task",
  "speaking.vocabulary": "Vocabulary",
  "speaking.grammar": "Grammar",
  "speaking.transcript": "Transcript",
  "speaking.tooShort": "The conversation ended before there was enough to grade — try a longer conversation next time.",
  "speaking.previous": "Previous conversations",
  "speaking.you": "You",
  "speaking.partner": "Partner",

  "billing.title": "Billing",
  "billing.subtitle": "Your plan, seats, and payment history.",
  "billing.notConfigured": "Online payment is not activated on this server yet — please contact us to arrange your plan.",
  "billing.currentPlan": "Current plan",
  "billing.trial": "Trial",
  "billing.seats": "Seats",
  "billing.renewsUntil": "Paid until",
  "billing.daysLeft": "days left",
  "billing.plans": "Plans",
  "billing.monthly": "Monthly",
  "billing.yearly": "Yearly",
  "billing.month": "month",
  "billing.year": "year",
  "billing.current": "Current",
  "billing.choose": "Choose plan",
  "billing.renew": "Renew",
  "billing.contactUs": "Contact us",
  "billing.paid": "Payment received — your plan is active!",
  "billing.cancelled": "Payment window closed — nothing was charged.",
  "billing.orders": "Payment history",
  "billing.date": "Date",
  "billing.plan": "Plan",
  "billing.amount": "Amount",
  "billing.status": "Status",

  "revenue.title": "Revenue",
  "revenue.subtitle": "Paid orders across all tenants.",
  "revenue.total": "Total collected",
  "revenue.paidOrders": "Paid orders",
  "revenue.tenant": "Tenant",
  "revenue.empty": "No payments yet.",

  "dashboard.aiTitle": "Your AI coaches are ready",
  "dashboard.aiBody": "Get instant, graded feedback on your exam writing and hold continuous voice conversations with the AI speaking partner — like having an expert on standby.",
  "dashboard.aiCta": "Go to Practice",
  "dashboard.examSkills": "Exam skills",
  "dashboard.examHint": "Mastery reflects your best scores per exam section.",
  "dashboard.focusAreas": "Focus areas",
  "dashboard.focusCommon": "Common B1 focus areas",
  "dashboard.focus.cases": "Case selection is tested heavily in Sprachbausteine.",
  "dashboard.focus.clauses": "Word order rules — the verb goes to the end.",
  "dashboard.focus.modals": "They appear in almost every Teil-1 text.",

  "monuments.title": "Landmark gallery",
  "monuments.subtitle": "European landmarks — each in both colour themes.",

  "player.check": "Check",
  "player.buildSentence": "Tap the words in the right order:",
  "player.continue": "Continue",
  "player.mnemonic": "Memory hook",
  "player.tableMissing": "This table is not available.",
  "player.yourText": "Your text",
  "player.wordCount": "{count} words",
  "player.compare": "Compare with a model answer",
  "player.modelAnswer": "Model answer",
  "player.saidIt": "I said it — show the model",
  "player.correct": "Correct!",
  "player.incorrect": "Not quite.",
  "player.answerWas": "Answer:",
  "player.loading": "Loading the recording…",
  "player.listen": "Listen",
  "player.pause": "Pause",
  "player.play": "Play",
  "player.restart": "Restart",
  "player.speed": "Speed",
  "player.transcript": "Transcript",
  "player.audioUnavailable": "Audio isn't available in this browser — read the transcript below.",
  "player.clear": "Clear",
  "player.finish.title": "Lesson complete!",
  "player.finish.score": "Score",
  "player.finish.backToCourse": "Back to course",
  "player.exit": "Exit lesson",

  "common.cancel": "Cancel",
  "common.showPassword": "Show password",
  "common.hidePassword": "Hide password",
  "common.close": "Close",
  "common.save": "Save",
  "common.saving": "Saving…",

  "nav.ai": "AI settings",
  "ai.title": "AI settings",
  "ai.subtitle": "Choose which AI service answers writing feedback, speaking practice and answer explanations. The change applies to every school straight away.",
  "ai.provider": "AI provider",
  "ai.recommended": "recommended",
  "ai.noKey": "no key yet",
  "ai.keyPresent": "Key installed",
  "ai.keyMissing": "No key installed",
  "ai.strictSchema": "Reliable feedback format",
  "ai.looseSchema": "Feedback format not guaranteed",
  "ai.noKeyHelp": "This provider has no API key on the server yet, so AI features stay switched off until one is added.",
  "ai.looseSchemaHelp": "This provider cannot guarantee the exact feedback format we ask for. We check every reply and retry once, but occasional failures are more likely than with the other providers.",
  "ai.saved": "AI provider updated.",
  "ai.saveFailed": "Could not update the AI provider.",
  "common.loading": "Loading…",
  "mock.noContent": "No practice exam is available for this level yet. Practice questions are still being added.",
  "common.error.generic": "Something went wrong. Please try again.",
  "doubt.title": "Ask a doubt",
  "doubt.intro": "Stuck on something? Ask in any language — Hindi, Punjabi, English — and we'll answer in that language.",
  "doubt.placeholder": "e.g. What's the difference between 'der' and 'die'?",
  "doubt.ask": "Ask",
  "doubt.off": "The AI tutor isn't available right now.",
  "translate.tapHint": "Tap to see the English",
  "translate.error": "Couldn't translate — tap to retry.",
  "common.required": "This field is required.",
} as const;

export type MessageKey = keyof typeof en;
